import { EntityPermission, IClaimContainer } from "./claims";
import { ParamsBase, IParamsBase } from "./params-base";

export class Role implements IClaimContainer {
  formattedPermissions?: string;
  id?: string;
  name?: string;
  permissions?: string[];
  isSelected?: boolean;
  description?: string;
  entityPermissions: { [key: string]: EntityPermission } = {};
}

export interface IRole {
  id?: string | null;
  name?: string | null;
  permissions?: string[] | null;
}

export enum UserRole {
  Admin = 'Administrator',
  SecondaryAdmin = 'Secondary Admin',
  BranchManager = 'Branch Manager',
  LoanOfficer = 'Loan Officer',
  Processor = 'Processor',
  Loa = 'Loan Officer Assistant',
  User = 'User',
  ReferralPartner = 'Referral Partner',
  VirtualAssistant = 'Virtual Assistant',
  Funder = 'Funder',
}

export class RoleParams extends ParamsBase {
}

export interface IRoleParams extends IParamsBase {
  isDeleted?: boolean;
}

export { EntityPermission };

export interface IPermissionsContainer {
  id?: string;
  name?: string;
  isExternal?: boolean;
  permissions?: string[];
}

export interface IRole {
  id?: string | null;
  name?: string | null;
  isExternal?: boolean;
  permissions?: string[] | null;
  isSelected?: boolean; // For UI use only
}
